export default __webpack_public_path__ + "static/media/Proverp_Info2.6c43c8d3.png";